import React from "react";
import { useParams } from "react-router-dom";

import { ContentWrapper } from "../../components/ContentWrapper";
import { TitleM } from "../../components/atoms/Typography";
import Users from "../Common/Users";
function ClientUsers() {
  const { id: clientId } = useParams();
  return (
    <ContentWrapper>
      <TitleM style={{ padding: "24px 0px" }}>Users</TitleM>
      <Users firmId={clientId || ""} />
    </ContentWrapper>
  );
}
export default ClientUsers;
